import { SLIDE_CLASSNAME } from "./constants";
import { CarouselSlideRoot } from "./styles";
import { CAROUSEL_SLIDE } from "../../common";
import { jsx as _jsx } from "react/jsx-runtime";
export var CarouselSlide = function CarouselSlide(_ref) {
  var children = _ref.children,
    minWidth = _ref.minWidth,
    style = _ref.style;
  return /*#__PURE__*/_jsx(CarouselSlideRoot, {
    className: SLIDE_CLASSNAME,
    "data-testid": CAROUSEL_SLIDE,
    minWidth: minWidth,
    style: style,
    children: children
  });
};
//# sourceMappingURL=CarouselSlide.js.map